import DataPointDetail from "../../../components/units/DataPoint/NotFound/DataPointDetail";

export default function DataPointNotFoundPage() {
  return <DataPointDetail />;
}
